import {fsa, fsaPayload, fsaError} from './helpers'

export const GET_SIZES = 'get user sizes asynchronously'
export const getSizes = fsa(GET_SIZES)

export const GET_SIZES_PENDING = 'get user sizes pending'
export const getSizesPending = fsa(GET_SIZES_PENDING)

export const GET_SIZES_FAILURE = 'get user sizes failure'
export const getSizesFailure = fsaError(GET_SIZES_FAILURE)

export const GET_SIZES_SUCCESS = 'get user sizes success'
export const getSizesSuccess = fsaPayload(GET_SIZES_SUCCESS)

export const SET_SIZES = 'set user sizes asynchronously'
export const setSizes = fsa(SET_SIZES)

export const SET_SIZES_PENDING = 'set user sizes pending'
export const setSizesPending = fsa(SET_SIZES_PENDING)

export const SET_SIZES_FAILURE = 'set user sizes failure'
export const setSizesFailure = fsaError(SET_SIZES_FAILURE)

export const SET_SIZES_SUCCESS = 'set user sizes success'
export const setSizesSuccess = fsaPayload(SET_SIZES_SUCCESS)
